import React from "react";
import PropTypes from "prop-types";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import {
  PageHeight40,
  PageTitle,
  scrollToTop,
  TableEmptyMessage,
  EMPLOYEE_TASKTYPE_LABELS,
  toUIDate,
  ScrollableTableHolder,
  createSortByAttr,
} from "../../../../components/Utils";
import { FormMenu } from "../../../../components/Buttons";
import ItemListManager from "../../../../components/ItemListManager";
import UserTaskMenu from "../../components/user/UserTaskMenu";
import TablePageReport from "../../../../components/TablePageReport";
import { connect } from "react-redux";
import {
  closeEmployeeTasks,
  deleteEmployeeTask,
  exportEmployeeTasks,
} from "../../actions/employee";
import { createWordBreakCellRenderer, renderRequesterColumn } from "../../components/Utils";

const mapStateToProps = (state) => {
  return {
    isLoading: state.task.loading,
    employeeTasks: state.task.employeeTasks,
  };
};
const mapDispatchToProps = (dispatch) => ({
  closeTasks: (...args) => dispatch(closeEmployeeTasks(...args)),
  deleteTask: (...args) => dispatch(deleteEmployeeTask(...args)),
  exportTasks: (...args) => dispatch(exportEmployeeTasks(...args)),
});

class UserTaskList extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    isLoading: PropTypes.bool,
    rows: PropTypes.number,
    employeeTasks: PropTypes.array,
    employeeTaskType: PropTypes.string,
    closeTasks: PropTypes.func.isRequired,
    deleteTask: PropTypes.func.isRequired,
    exportTasks: PropTypes.func.isRequired,
  };
  static defaultProps = {
    className: "",
    rows: 10,
    employeeTasks: [],
  };
  constructor(props) {
    super(props);
    this.state = {
      first: null,
      selection: [],
    };
  }
  componentDidMount() {
    scrollToTop();
  }
  onClose = (task) => {
    const { closeTasks } = this.props;
    closeTasks({ tasks: [task] });
  };
  onDelete = (task) => {
    const { deleteTask } = this.props;
    console.log("onDelete()", task);
    deleteTask({ task });
  };
  render() {
    const {
      className,
      isLoading,
      rows,
      employeeTasks,
      closeTasks,
      deleteTask,
      exportTasks,
      disabled,
    } = this.props;
    const { selection } = this.state;
    const setSelection = (value) => this.setState({ selection: value });

    const columnStyle = {
      verticalAlign: "top",
      paddingTop: "16px",
      paddingBottom: "16px",
    };
    const renderItemTable = (items, actionTemplate) => {
      const taskItems = items
        .map((item) => ({
          ...item,
          employee: `${item.userData.firstname} ${item.userData.lastname}`,
          vfEmail: item.userData.vf_email,
          typeName: item.typeName || EMPLOYEE_TASKTYPE_LABELS[item.type],
          requester: `${item.requester || ""}`.split(",").join(" "),
          requestDateUI: toUIDate(
            item.request_date,
            "YYYY-MM-DDTHH:mm:ss:SSSZ",
          ),
          requestDate: toUIDate(
            item.request_date,
            "YYYY-MM-DDTHH:mm:ss:SSSZ",
            "YYYY.MM.DD",
          ),
        }))
        .sort(createSortByAttr("request_date", true, true));
      return (
        <ScrollableTableHolder>
          <DataTable
            value={taskItems}
            paginator={taskItems.length > rows}
            rows={rows}
            first={this.state.first}
            onPage={(event) => {
              this.setState({ first: event.first });
              scrollToTop();
            }}
            paginatorLeft={
              <TablePageReport
                className="pad-lft"
                totalRecords={taskItems.length}
                filteredRecords={taskItems.length}
                first={this.state.first}
                rows={rows}
                emptyText="Keine Benutzeraufgaben"
                itemName="Benutzeraufgabe"
                itemNamePlural="Benutzeraufgaben"
              />
            }
            selection={selection}
            onSelectionChange={(event) => setSelection(event.value)}
            removableSort
            sortMode="multiple"
            emptyMessage={
              isLoading ? null : (
                <TableEmptyMessage itemNamePlural="Benutzeraufgaben" />
              )
            }
            scrollable
          >
            <Column
              id="icheck"
              selectionMode="multiple"
              style={{ ...columnStyle, width: "3em" }}
            />
            <Column
              field="parentCompanyName"
              header="Vertragspartner"
              sortable={taskItems.length > 1}
              filter // ={taskItems.length > rows}
              filterMatchMode="contains"
              style={{ ...columnStyle, width: "16em" }}
            />
            <Column
              field="employee"
              header="Mitarbeiter"
              sortable={taskItems.length > 1}
              filter // ={taskItems.length > rows}
              filterMatchMode="contains"
              style={{ ...columnStyle, width: "14em" }}
            />
            <Column
              field="vfEmail"
              header="Vodafone E-Mail"
              sortable={taskItems.length > 1}
              filter // ={taskItems.length > rows}
              filterMatchMode="contains"
              style={{ ...columnStyle, width: "15em" }}
              body={createWordBreakCellRenderer("vfEmail")}
            />
            <Column
              field="typeName"
              header="Geändert"
              sortable={taskItems.length > 1}
              filter // ={taskItems.length > rows}
              filterMatchMode="contains"
              style={{ ...columnStyle, width: "10em" }}
            />
            <Column
              field="fromValue"
              header="Von"
              sortable={taskItems.length > 1}
              filter // ={taskItems.length > rows}
              filterMatchMode="contains"
              style={{ ...columnStyle, width: "15em" }}
              body={createWordBreakCellRenderer("fromValue")}
            />
            <Column
              field="toValue"
              header="Zu"
              sortable={taskItems.length > 1}
              filter // ={taskItems.length > rows}
              filterMatchMode="contains"
              style={{ ...columnStyle, width: "15em" }}
              body={createWordBreakCellRenderer("toValue")}
            />
            <Column
              field="requester"
              header="Beantrager"
              sortable={taskItems.length > 1}
              filter // ={taskItems.length > rows}
              filterMatchMode="contains"
              style={{ ...columnStyle, width: "15em" }}
              body={renderRequesterColumn}
            />
            <Column
              field="requestDate"
              header="Erstelldatum"
              sortable={taskItems.length > 1}
              filter // ={taskItems.length > rows}
              filterMatchMode="contains"
              style={{ ...columnStyle, width: "10em", textAlign: "center" }}
              body={(item) => item.requestDateUI}
            />
            {/* <Column
              field="status"
              header="Status"
              sortable={taskItems.length > 1}
              filter // ={taskItems.length > rows}
              filterMatchMode="contains"
              style={{textAlign:'center-', width: '9em'}}
            /> */}
            <Column
              body={actionTemplate}
              style={{
                verticalAlign: "top",
                textAlign: "center",
                width: "7.4em",
              }}
            />
          </DataTable>
        </ScrollableTableHolder>
      );
    };

    const renderItemForm = (item, onHide) => {
      return (
        <div>
          <div className="w3-large">{`Wollen Sie diese Aufgabe wirklich schließen?`}</div>
          <FormMenu
            className="margin-big-top w3-border-top pad-big"
            style={{
              marginLeft: "-1em",
              marginRight: "-1em",
              marginBottom: "-1em",
            }}
            onSave={() => this.onClose(item)}
            onCancel={onHide}
            saveBtnName="closeEmployeeTaskBtn"
            saveBtnLabel="Schließen"
          />
        </div>
      );
    };
    const getItemFormTitle = (/* employeeTask */) => {
      let title = "Benutzeraufgabe schließen";
      return <h3 className="no-margin">{title}</h3>;
    };
    const title = (
      <PageTitle>
        <UserTaskMenu
          className="w3-right"
          selectedUserTasks={selection}
          closeTasks={closeTasks}
          exportTasks={exportTasks}
          items={employeeTasks}
        />
        <h3 className="no-margin pad-btm">{"Änderung Kontaktdaten"}</h3>
      </PageTitle>
    );
    return (
      <PageHeight40 className={className}>
        <ItemListManager
          key={Math.random()}
          itemPanelStyle={{ width: "40rem" }}
          title={title}
          addBtnHidden
          items={employeeTasks}
          getItemFormTitle={getItemFormTitle}
          renderItemTable={renderItemTable}
          renderItemForm={renderItemForm}
          namePrefix={`Benutzer`}
          itemDeleteable
          deleteTitle={`Kontaktdatenänderungsaufgabe ablehnen`}
          getDeleteText={(_item) =>
            `Wollen Sie die Änderung dieser Kontaktdaten wirklich ablehnen?`
          }
          onDelete={this.onDelete}
          showItemDeleteReason
          reasonTitle="Ablehnungstext"
          // itemCloseableOnly
          // hideDisabledClose
          // isCloseDisabled={() => disabled}
          // closeTitle={`Benutzeraufgabe schließen`}
          // getCloseText={() => `Wollen Sie diese Aufgabe wirklich schließen?`}
          // onClose={this.onClose}
        />
      </PageHeight40>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserTaskList);
